import { values } from './enums'

const _enum = {
  Undefined: 0,
  ReportSubmissionGroupDetail: 1,
  OutputReportGroupDetail: 2,
  ReportSubmissionSubmitDetail: 3
}

export const routeType = {
  enumName: 'RouteType',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/routeType.js